import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const badges = [
    {
      icon: 'Shield',
      text: 'SSL Encrypted'
    },
    {
      icon: 'Lock',
      text: 'Secure Login'
    },
    {
      icon: 'CheckCircle',
      text: 'Industry Compliant'
    }
  ];

  return (
    <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 lg:gap-8">
      {badges?.map((badge, index) => (
        <div
          key={index}
          className="flex items-center gap-2 text-muted-foreground"
        >
          <Icon name={badge?.icon} size={16} className="flex-shrink-0" />
          <span className="text-xs md:text-sm font-medium">{badge?.text}</span>
        </div>
      ))}
    </div>
  );
};

export default SecurityBadges;